import styles from './styles.module.scss';

const Heading3 = ({ className = '', text, id }) => (
    <h3 id={id} className={`${styles.heading3} ${className}`}>
        {text}
    </h3>
);

export default Heading3;
